import { selector } from 'recoil';
import { modalAtom } from './atoms';

export const modalSelector = selector({
  key: 'MODAL_SELECTOR',
  get: ({ get }) => get(modalAtom),
  set: ({ get, set }, newValue) => {
    const atom = get(modalAtom);
    set(modalAtom, {
      ...atom,
      ...newValue,
    });
  },
});
